import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { Athlete, AthleteWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCreateAthlete(): UseMutationResult<
  AxiosResponse<Athlete>,
  AxiosError<ErrorMessage>,
  AthleteWrite
> {
  const queryClient = useQueryClient();

  const createAthlete = (athlete: AthleteWrite): Promise<AxiosResponse<Athlete>> => {
    return client.post('athletes/', athlete);
  };

  return useMutation(createAthlete, {
    onSuccess: () => {
      queryClient.invalidateQueries('athletes');
    },
  });
}
